import { TicketCart } from '@/@types'
import { computed, ref } from 'vue'

export function useTicketCart() {
  const total = ref(0)
  const totalToDiscount = ref(5)
  const ticketCart = ref<TicketCart[]>([])

  function updateTotal({
    price,
    type,
    ticket,
    currentTotal,
    maxTickets = 1500,
  }: {
    price: number
    type: 'increment' | 'decrement' | 'direct'
    ticket: TicketCart
    currentTotal: number
    maxTickets?: number
  }) {
    switch (type) {
      case 'increment':
        if (currentTotal >= maxTickets) break

        total.value += price
        totalToDiscount.value--
        break
      case 'decrement':
        total.value -= price
        totalToDiscount.value++
        break
      case 'direct':
        total.value = currentTotal * price
        totalToDiscount.value = totalToDiscount.value > 5 ? 0 : 5 - currentTotal
        break
    }

    updateTicketCart(ticket)
  }

  function updateTicketCart(ticket: TicketCart) {
    const existingIndex = ticketCart.value.findIndex(
      item => item.ticket_id === ticket.ticket_id
    )

    if (existingIndex !== -1) {
      ticketCart.value[existingIndex] = ticket
    } else {
      ticketCart.value.push(ticket)
    }
  }

  const price = computed(() => {
    const discount = totalToDiscount.value <= 0 ? 0.1 : 0
    const discountAmount = total.value * discount

    return {
      finalPrice: total.value - discountAmount,
      discount: discountAmount,
    }
  })

  return {
    total,
    totalToDiscount,
    ticketCart,
    price,
    updateTotal,
  }
}